import PropTypes from 'prop-types'
import { useState } from 'react'

import VideoAccessDialog from '../../common/components/VideoAccessDialog'
import VideoCard from './VideoCard'

export default function VideoCardHit({ hit, userHasAccess, userLoggedIn }) {
  const [isAccessDialogOpen, setIsAccessDialogOpen] = useState(false)

  const serializedVideo = {
    ...hit,
    title: hit.title,
    image: hit.image_url,
    subtitle: hit.subtitle,
    category: hit.category,
    genre: hit.genre,
  }

  return (
    <>
      <VideoCard
        video={serializedVideo}
        isUserAllowed={userHasAccess}
        openInfoModal={() => setIsAccessDialogOpen(true)}
        showCategory
      />

      <VideoAccessDialog
        open={isAccessDialogOpen}
        onOpenChange={open => setIsAccessDialogOpen(open)}
        userLoggedIn={userLoggedIn}
      />
    </>
  )
}

VideoCardHit.propTypes = {
  hit: PropTypes.shape({
    category_title: PropTypes.string.isRequired,
    image_url: PropTypes.string.isRequired,
    image_grayscale_url: PropTypes.string.isRequired,
    thumbnail_url: PropTypes.string.isRequired,
  }).isRequired,
  userHasAccess: PropTypes.bool.isRequired,
  openInfoModal: PropTypes.func.isRequired,
}
